<div class="request">
  @if (payload().question; as question) {
    <p class="question">{{ question }}</p>
  }

  @if (validationError(); as error) {
    <p class="error" role="alert">{{ error }}</p>
  }

  @switch (payload().dataType) {
    @case ('Enum') {
      <app-agent-quick-replies
        [options]="payload().options"
        ariaLabel="Answer options"
        (select)="onEnumSelect($event)"></app-agent-quick-replies>
      @if (payload().allowFreeText) {
        @if (showFreeText()) {
          <input
            class="field"
            type="text"
            [attr.aria-label]="payload().question"
            [value]="textValue()"
            (input)="onText($event)"
            (keydown.enter)="submit()" />
          <div class="actions">
            <button
              formaButton="primary"
              type="button"
              [disabled]="!canSubmit()"
              (click)="submit()">
              {{ 'INSIGHT.GLOBAL.SUBMIT' | transloco }}
            </button>
          </div>
        } @else {
          <button class="other" type="button" (click)="showFreeText.set(true)">
            {{ otherLabel() }}
          </button>
        }
      }
    }
    @case ('Bool') {
      <div class="chips">
        <forma-chips (click)="submitted.emit('true')">
          {{ 'INSIGHT.GLOBAL.YES' | transloco }}
        </forma-chips>
        <forma-chips (click)="submitted.emit('false')">
          {{ 'INSIGHT.GLOBAL.NO' | transloco }}
        </forma-chips>
      </div>
    }
    @case ('Date') {
      <input
        class="field"
        type="date"
        [attr.aria-label]="payload().question"
        [value]="textValue()"
        (input)="onText($event)" />
      <div class="actions">
        <button formaButton="primary" type="button" [disabled]="!canSubmit()" (click)="submit()">
          {{ 'INSIGHT.GLOBAL.SUBMIT' | transloco }}
        </button>
      </div>
    }
    @default {
      <input
        class="field"
        type="text"
        [attr.aria-label]="payload().question"
        [attr.inputmode]="payload().dataType === 'Number' ? 'numeric' : null"
        [value]="textValue()"
        (input)="onText($event)"
        (keydown.enter)="submit()" />
      <div class="actions">
        <button formaButton="primary" type="button" [disabled]="!canSubmit()" (click)="submit()">
          {{ 'INSIGHT.GLOBAL.SUBMIT' | transloco }}
        </button>
      </div>
    }
  }

  @if (payload().allowSkip) {
    <forma-chips (click)="skipped.emit()" class="skip">
      {{ 'INSIGHT.GLOBAL.SKIP' | transloco }}
    </forma-chips>
  }
</div>
